<template>
  <b-sidebar
    id="nav-sidebar"
    backdrop
    shadow
    >
    <div id="nav">
      <div id="userinfo">
        <b-img thumbnail width="200" height="200" :src="vendor.company_logo_url"></b-img>
        <h3>Hello, {{ user.first_name }}</h3>
      </div>
      <div id="links">
        <div v-if="vendor.id!=1">
          <b-row><b-col><b-link v-if="$auth.isAuthenticated" to="/"><h5>DASH<b>BOARD</b></h5></b-link></b-col></b-row>
          <b-row><b-col><b-link v-if="$auth.isAuthenticated" to="/Orders"><h5>VIEW ORDERS</h5></b-link></b-col></b-row>
          <b-row><b-col>
            <router-link v-if="$auth.isAuthenticated" :to="{ name: 'PlaceOrder', params: {vendorId: vendor.id }}">
              <h5>NEW ORDER</h5>
            </router-link>
          </b-col></b-row>
          <!-- <b-row><b-col><b-link v-if="$auth.isAuthenticated" disabled to="/Customers"><h5>CUSTOMERS</h5></b-link></b-col></b-row> -->
          <!-- <b-row><b-col><b-link v-if="$auth.isAuthenticated" v-b-toggle.menu-nav to="/Menu"><h5>MENU</h5></b-link></b-col></b-row> -->
          <b-row><b-col><b-link v-if="$auth.isAuthenticated" v-b-toggle.menu-nav><h5>MENU</h5></b-link></b-col></b-row>
          <b-collapse id="menu-nav">
            <b-row><b-col><b-link v-if="$auth.isAuthenticated" to="/MenuProductLists"><h5 class="pl-2">PRODUCT LISTS</h5></b-link></b-col></b-row>
            <b-row><b-col><b-link v-if="$auth.isAuthenticated" to="/MenuCategories"><h5 class="pl-2">CATEGORIES</h5></b-link></b-col></b-row>
            <b-row><b-col><b-link v-if="$auth.isAuthenticated" to="/MenuItems"><h5 class="pl-2">ITEMS</h5></b-link></b-col></b-row>
            <b-row><b-col><b-link v-if="$auth.isAuthenticated" to="/MenuOptions"><h5 class="pl-2">ITEM OPTIONS</h5></b-link></b-col></b-row>
            <b-row><b-col><b-link v-if="$auth.isAuthenticated" to="/MenuChoices"><h5 class="pl-2">OPTIONS CHOICES</h5></b-link></b-col></b-row>
          </b-collapse>
          <b-row><b-col><b-link v-if="$auth.isAuthenticated" to="/Locations"><h5>LOCATIONS</h5></b-link></b-col></b-row>
          <b-row><b-col><b-link v-if="$auth.isAuthenticated" to="/Reports"><h5>REPORTS</h5></b-link></b-col></b-row>
          <b-row><b-col><b-link v-if="$auth.isAuthenticated" to="/Transactions"><h5>PAYMENTS</h5></b-link></b-col></b-row>
          <b-row><b-col><b-link v-if="$auth.isAuthenticated" to="/GiftCards"><h5>GIFTCARDS</h5></b-link></b-col></b-row>
          <b-row><b-col><b-link v-if="$auth.isAuthenticated" to="/Settings"><h5>SETTINGS</h5></b-link></b-col></b-row>
          <b-row><b-col><b-link v-if="$auth.isAuthenticated" to="/Printers"><h5>PRINTERS</h5></b-link></b-col></b-row>
        </div>
        <div v-else>
          <b-row><b-col><b-link v-if="$auth.isAuthenticated" to="/Onboard"><h5>ONBOARD</h5></b-link></b-col></b-row>
          <b-row><b-col><b-link v-if="$auth.isAuthenticated" to="/Performance"><h5>PERFORMANCE</h5></b-link></b-col></b-row>
        </div>
        <!-- Check that the SDK client is not currently loading before accessing is methods -->
        <div v-if="!$auth.loading">
          <!-- show login when not authenticated -->
          <b-row><b-col><b-link v-if="!$auth.isAuthenticated" @click="login"><h5>LOG<b>IN</b></h5></b-link></b-col></b-row>
          <!-- show logout when authenticated -->
          <b-row><b-col><b-link v-if="$auth.isAuthenticated" @click="logout"><h5>LOG<b>OUT</b></h5></b-link></b-col></b-row>
        </div>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
export default {
  name: 'SideBar',
  data() {
    return {
        user: [],
        vendor: []
    }
  },
  methods: {
    // Log the user in
    login() {
      this.$auth.loginWithRedirect();
    },
    // Log the user out
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    },

    async retrieveUser() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      // Use Axios to make a call to the API
      const { data } = await this.$api.get("users", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      const users = await data.users;
      for (let idx in users) {
        if ('auth0|'+users[idx].user_account_id == this.$auth.user.sub) {
          this.user = users[idx];
        }
      }
    },

    async retrieveVendor() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      // Use Axios to make a call to the API
      const { data } = await this.$api.get("ownvendor", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.vendor = await data.vendor;
    },

    async retrieveAdminVendor() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      // Use Axios to make a call to the API
      await this.$api.get("vendors/1", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      }).then(response=> {
        if (response.data.success==true) {
          this.vendor = response.data.vendor;
        }
      }).catch(error => {
        // fake conditional to prevent error reporting
        if (error.message.includes('401') || error.message.includes('500')) {
          this.retrieveUser();
          this.retrieveVendor();
        }
      })
    },

    async loadSidebarInfo() {
      await this.retrieveAdminVendor();
      // if (this.vendor == []) {
      //   this.retrieveUser();
      //   this.retrieveVendor();
      // }
    }

  },
  created: function() {
    if (this.$auth.isAuthenticated) {
        this.loadSidebarInfo();
    }

  }
}
</script>

<style>

#userinfo {
  text-align: center;
}

#links {
  text-align: left;
  margin-left: 2rem;
  margin-top: 3rem;
}

#links a {
  color: black;
}

#links a.router-link-active h5 {
  font-weight: bold;
}

#links a.disabled {
  pointer-events: none;
  color: gray;
}

</style>
